import { useMemo, useState } from "react";
import DataTable from "../../../../../components/DataTable";
import useFetchSurveysTemplate from "./useFetchSurveysTemplate";
import { Tooltip } from "@material-ui/core";
import * as dateFNS from "date-fns";
import { BiEdit, BiTrash } from "react-icons/bi";
import {
  NewSurveyLink,
  RowActionButton,
  RowActionLink,
  RowActionsContainer,
  TableTitle,
  TableToolbarContainer,
} from "./styles";
import { SURVEY_STATUS } from "../../constants";
import SurveyTemplateRowActions from "./SurveyTemplateRowActions";

export default function SurveysTemplateTable() {
  const [selectedFilters, setSelectedFilters] = useState({});
  const { 
    data, 
    page, 
    rowsPerPage,
    loading, 
    changePage,
    changeRowsPerPage,
    refetch 
  } = useFetchSurveysTemplate({ search: selectedFilters?.search });

  /**@type {import("../../../../../components/DataTable/interfaces").TableColumn[]} */
  const columns = [
    { key: "id", name: "ID", align: 'center', width: '20px' },
    { key: "name", name: "Nome" },
    { key: "created_at", name: "Criado em", align: 'center', width: '120px' },
    { key: "actions", name: "Ações", align: 'center', width: '160px' },
  ];

  const rows = useMemo(() => {
    return data?.data?.map((item) => {
      return {
        id: item.id,
        name: item.name,
        created_at: dateFNS.format(new Date(item.created_at), "dd/MM/yyyy"),
        actions: <SurveyTemplateRowActions surveyTemplateID={item.id} onDelete={refetch} />,
      };
    });
  }, [data, refetch]);

  /**@type {import("../../../../../components/DataTable/interfaces").TableFilter[]} */
  const filters = [
    {
      key: "search",
      name: "Nome do modelo da pesquisa",
      component: { type: "text", placeholder: "Busque pelo nome do modelo da pesquisa" },
    },
  ];

  return (
    <DataTable
      hasStickHeader
      showPagination
      showFilters
      CustomToolbarElement={
        <TableToolbarContainer>
          <TableTitle>Modelos de Pesquisa</TableTitle>
        </TableToolbarContainer>
      }
      columns={columns}
      rows={rows}
      filters={filters}
      isLoading={loading}
      page={page}
      rowsPerPage={rowsPerPage}
      totalRecords={data?.paging?.total}
      selectedFilters={selectedFilters}
      onPageChange={changePage}
      onRowsPerChange={changeRowsPerPage}
      onSubmitFilters={(filters) => setSelectedFilters(filters)}
      onResetFilters={() => setSelectedFilters({})}
    />
  );
}
